import { makeStyles } from '@material-ui/core/styles';

export const AllPatientsCss = makeStyles(theme => ({


  content: {

    marginTop: 50,
    padding: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      marginLeft: "240px",

    },
  },
  toolbar: theme.mixins.toolbar,
  tabStyle: {

    borderRadius: '25%',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    margin: 0,
    height: 'auto'
  },
  date: {
    display: 'flex',
    padding: '20px',
    justifyContent: 'spaceBetween'
  },
  date2:{
    margin: '10px'
  }




}));